<template>
  <bv-call-details
    expanded
    hide-intersection-actions
    :show-expand
    show-transfer
    @on-collapse="collapse"
    @on-transfer="transferCall"
  />
  <transfer-dialog
    v-if="currentRoute.query.transfer"
    @on-close="closeTransfer"
  />
</template>

<script setup lang="ts">
  import { BvCallDetails } from '@bv/components';
  import { type Call, useSipStore } from '@bv/stores';
  import { storeToRefs } from 'pinia';
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';

  import TransferDialog from '@/components/WebPhone/NestedViews/Dial/TransferDialog/TransferDialog.vue';

  const { push, replace, currentRoute } = useRouter();

  const sipStore = useSipStore();

  const { activeCall } = storeToRefs(sipStore);
  const showExpand = computed<boolean>(() => {
    return !!activeCall?.value;
  });

  const collapse = () => {
    push({ name: 'call-center' });
  };

  const closeTransfer = () => {
    replace({
      query: {
        transfer: undefined,
      },
    });
  };

  const transferCall = async (call: Call) => {
    const { transfer } = await import('@/plugins/sip');
    transfer(call);
  };
</script>
